<template lang="pug">
.my-5
  v-form(@submit.prevent="submit()")
    v-text-field(v-model="search", label="Search Products")
  v-btn(
    text,
    v-for="(item, index) in products",
    :key="index",
    @click="addItem(item)"
  ) {{ item.name }}
</template>

<script>
export default {
  data() {
    return {
      search: "",
      products: [],
    };
  },
  methods: {
    async submit() {
      const search = this.search.trim();
      if (!search) return;
      if (search.length < 3) {
        return this.$toast.error("Please enter with at least 3 letters");
      }
      const params = {
        criteria: { name: { $regex: search, $options: "i" } },
        select: "name",
      };
      this.products = await this.$api.catalog.product.list(params);
    },
    addItem(item) {
      if (!item) return;
      this.$emit("add", item);
    },
  },
};
</script>